import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { formatValue } from "../labels";

const STATUS_COLOR = {
  good: "#2fd575",
  bad: "#ff5c5c",
  no_data: "#8b9bb4",
};

const PLAN_COLOR = "rgba(148, 163, 184, 0.55)";
const AXIS_COLOR = "#8b9bb4";
const GRID_COLOR = "rgba(148, 163, 184, 0.12)";

/** Перенос длинных названий в chart.js — массив строк = многострочная подпись */
const wrapLabel = (text, max = 34) => {
  if (text.length <= max) return text;
  const words = text.split(" ");
  const lines = [];
  let line = "";
  words.forEach((w) => {
    if ((line + " " + w).trim().length > max) {
      if (line) lines.push(line.trim());
      line = w;
    } else {
      line = (line + " " + w).trim();
    }
  });
  if (line) lines.push(line.trim());
  return lines;
};

/**
 * Горизонтальная диаграмма «План и факт по показателям» (ТЗ п.5.6).
 * Данные — items[] за отчётный период, порядок sort_order.
 * Факт: цвет столбца = статус; no_data → столбец не рисуется (null, не 0),
 * к подписи строки добавляется пометка «нет данных».
 * Высота растёт с числом показателей — секция не «давит» столбцы.
 */
const PlanFactChart = ({ items, lang, L }) => {
  const labels = items.map((it) => {
    const name = lang === "kz" ? it.name_kz : it.name_ru;
    const suffix = it.status === "no_data" ? ` · ${L.noDataCount}` : "";
    return wrapLabel(name + suffix);
  });

  const data = {
    labels,
    datasets: [
      {
        label: L.plan,
        backgroundColor: PLAN_COLOR,
        borderWidth: 0,
        data: items.map((it) => (it.plan === null ? null : it.plan)),
      },
      {
        label: L.fact,
        backgroundColor: items.map((it) => STATUS_COLOR[it.status]),
        borderWidth: 0,
        // no_data → null: chart.js пропускает столбец (не рисует «0»)
        data: items.map((it) => (it.fact === null ? null : it.fact)),
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    legend: {
      position: "top",
      labels: { fontColor: AXIS_COLOR, boxWidth: 14 },
    },
    tooltips: {
      backgroundColor: "#1a2740",
      borderColor: "#2c3d5e",
      borderWidth: 1,
      callbacks: {
        label: (t, d) => {
          const dsLabel = d.datasets[t.datasetIndex].label;
          return `${dsLabel}: ${formatValue(t.xLabel)}`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: { fontColor: AXIS_COLOR, beginAtZero: true },
          gridLines: { color: GRID_COLOR, zeroLineColor: GRID_COLOR },
        },
      ],
      yAxes: [
        {
          ticks: { fontColor: "#c6d2e4", fontSize: 11 },
          gridLines: { display: false },
          barPercentage: 0.75,
          categoryPercentage: 0.7,
        },
      ],
    },
  };

  // Динамическая высота: ~52px на показатель (ТЗ п.5.6 / п.8: 20–30+ строк)
  const height = Math.max(360, items.length * 52 + 80);

  return (
    <div className="hc-chart">
      <div className="hc-chart__note">{L.factColorNote}</div>
      <div style={{ height }}>
        <HorizontalBar data={data} options={options} />
      </div>
    </div>
  );
};

export default PlanFactChart;
